module.exports = __webpack_public_path__ + "assets/img/TradewithMaybankImg.08412639.png";